import type { WelcomeStep } from "../types/WelcomeFlowTypes";

// The tour's centered intro; anchored steps load live from the Project Dashboard flow guide.
export const projectNewUserSteps: WelcomeStep[] = [{ key: "project-welcome", label: "Welcome", centered: true }];
